var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container__ranking",
      class: { active: !_vm.noExpandTable, "no__data-to-show": _vm.emptyTable }
    },
    [
      _c("v-data-table", {
        staticClass: "table__ranking",
        class: { no__expand_table: _vm.noExpandTable },
        attrs: {
          headers: _vm.headers,
          items: _vm.affiliationsRanking,
          pagination: _vm.paginationranking,
          "rows-per-page-items": _vm.itemsPerPage
        },
        on: {
          "update:pagination": function($event) {
            _vm.paginationranking = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "headers",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  _vm._l(props.headers, function(header) {
                    return _c(
                      "th",
                      {
                        key: header.text,
                        class: [
                          "column sortable",
                          _vm.paginationranking.descending ? "desc" : "asc"
                        ]
                      },
                      [_vm._v("          " + _vm._s(header.text))]
                    )
                  })
                )
              ]
            }
          },
          {
            key: "items",
            fn: function(props) {
              return [
                _c("td", [_vm._v(_vm._s(props.item.IdRanking))]),
                _c("td", [_c("span", [_vm._v(_vm._s(props.item.Seller))])]),
                _c("td", { staticClass: "text-xs-right" }, [
                  _vm._v(_vm._s(props.item.POSInalam))
                ]),
                _c("td", { staticClass: "text-xs-right" }, [
                  _vm._v(_vm._s(props.item.POSFijo))
                ]),
                _c("td", { staticClass: "text-xs-right" }, [
                  _vm._v(_vm._s(props.item.PagoWEB))
                ]),
                _c("td", { staticClass: "text-xs-right" }, [
                  _vm._v(_vm._s(props.item.PagoAPP))
                ]),
                _c("td", { staticClass: "text-xs-right" }, [
                  _vm._v(_vm._s(props.item.PagoLink))
                ]),
                _c("td", { staticClass: "text-xs-right" }, [
                  _vm._v(
                    _vm._s(
                      Number(props.item.PagoLink) +
                        Number(props.item.PagoAPP) +
                        Number(props.item.PagoWEB) +
                        Number(props.item.POSFijo) +
                        Number(props.item.POSInalam)
                    )
                  )
                ])
              ]
            }
          }
        ])
      }),
      _c(
        "p",
        {
          staticClass: "table__see_more",
          class: { active: _vm.showBtn && !_vm.showPaginator },
          on: { click: _vm.showMoreTable }
        },
        [_vm._v("Ver todos los vendedores")]
      ),
      _c(
        "nuxt-link",
        {
          staticClass: "ranking__link-responsive",
          staticStyle: { "text-transform": "upperCase", padding: "10px" },
          attrs: { to: "dashboard/ranking" }
        },
        [_vm._v("Ver todos los vendedores")]
      ),
      _c("pagination-box", {
        staticClass: "ranking__pagination",
        class: { active: _vm.showPaginator },
        attrs: { "total-pages": _vm.totalItems },
        on: { input: _vm.pagination }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-082ef35c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-082ef35c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/ranking-table.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-082ef35c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/ranking-table.vue
// module chunks = 5